import ServicesHotel from "./ServicesHotel";

export default ServicesHotel;
